module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('a', {
    attrs: {
      "id": "p18"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-weight": "bold",
      "font-family": "arial"
    }
  }, [_c('span', {
    staticClass: "color-FF5100"
  }, [_vm._v("Scallops & Prosciutto on Rosemary Skewers")])]), _vm._v(" "), _c('p', {
    staticClass: "recipe_hdnote"
  }, [_c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-14"
  }, [_vm._v("Because scallops cook so quickly, you can use rosemary sprigs as the skewers. This not only looks cool to The Progeny, but also gives the scallops an infusion of rosemary flavor while they grill. They also make a nice impression with the guests. And pruning the twiggy sprigs for their “skewers of duty” is definitely something The Progeny can be responsible for.")])])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "yield font-GoudyHeavyfaceBT-Regular-3_1-9_5 color-3C1C00"
  }, [_vm._v("Serves ")]), _c('span', {
    staticClass: "yield color-FF5100"
  }, [_c('span', {
    staticClass: "yield font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("6 ")])]), _c('span', {
    staticClass: "yield color-3C1C00"
  }, [_c('span', {
    staticClass: "yield font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("as an appetizer")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "running_txt"
  }, [_c('span', {
    staticClass: "color-FF5100 font-GoudyHeavyfaceBT-Regular-3_1-11_75"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred_list"
  }, [_c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("6")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("fresh rosemary sprigs, each ")])]), _c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("4")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("inches long "), _c('br')])]), _c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("4")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("ounces prosciutto, sliced paper-thin "), _c('br')])]), _c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("12")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("sea scallops, crescent-shaped membrane removed "), _c('br')])]), _c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("3")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("tablespoons extra virgin olive oil "), _c('br')])]), _c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("1")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("lemon, cut in half "), _c('br'), _vm._v("Salt and freshly ground black pepper")])])])]), _vm._v(" "), _c('p', {
    staticClass: "method_text"
  }, [_c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-FFDingbats-ArrowsOne-11_1-14"
  }, [_vm._v("→")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("Strip ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-12"
  }, [_vm._v("the leaves off the bottom 2 inches of each rosemary sprig, exposing the woody stem. Cut the prosciutto slices in half lengthwise. Wrap a piece of prosciutto around each scallop. Skewer the scallops crosswise with the rosemary sprigs, 2 scallops per sprig, making sure to skewer the prosciutto as well. Arrange the skewers on a platter. Drizzle both sides with olive oil, squeeze lemon juice over them, and season to taste with salt and pepper. Let stand while you prepare the fire.")])])]), _vm._v(" "), _c('p', {
    staticClass: "method_text color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("Prepare ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-12"
  }, [_vm._v("enough coals for a hot charcoal fire, or preheat your gas grill on high for 10 minutes with the lid closed.")])]), _vm._v(" "), _c('p', {
    staticClass: "method_text color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("When ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-12"
  }, [_vm._v("the coals are ready or the gas grill is hot, grill the scallops for 3 minutes. Turn and grill for 2 to 3 minutes more, until they are just cooked through.")])]), _vm._v(" "), _c('p', {
    staticClass: "method_text color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("Serve ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-12"
  }, [_vm._v("immediately.")])])])]), _c('a', {
    attrs: {
      "id": "p18"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ffa65b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/011chapter05.vue
// module id = 87
// module chunks = 0